import { UNASSIGNED_FILTER_VALUE } from '~/client/src/shared/utils/ZoneLevelLocationConstants'

export const toFilterOptionIds = (raw: unknown): string[] => {
  if (Array.isArray(raw)) {
    return raw.length
      ? raw.map(value => String(value))
      : [UNASSIGNED_FILTER_VALUE]
  }

  if (raw == null || raw === '') {
    return [UNASSIGNED_FILTER_VALUE]
  }

  return [String(raw)]
}

export const isUnassignedFilterOptionId = (optionId: string): boolean =>
  optionId === UNASSIGNED_FILTER_VALUE
